import React, { useEffect, useState, useRef } from "react";
import skillsImg from './images/skills.jpg'
import useIntersectionObserver from "./home-animation";

export default function HomeSkills() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [counted, setCounted] = useState(false);
    const countRefs = useRef([]);
    const barRefs = useRef([]);

    useEffect(() => {
        const handleScroll = () => {
            if (!counted && isVisible1 && isVisible2) {
                countRefs.current.forEach((ref, index) => {
                    const countTo = parseInt(ref.getAttribute("data-count"), 10);
                    animateCount(ref, countTo, 2000);
                });
                barRefs.current.forEach((ref, index) => {
                    const targetWidth = ref.getAttribute("data-width");
                    ref.style.width = `${targetWidth}%`;
                    ref.classList.add('animated');
                });
                setCounted(true); // Update the state to prevent animation on subsequent scrolls
            }
        };

        const animateCount = (element, countTo, duration) => {
            const start = parseInt(element.innerText, 10);
            let startTime = null;

            const step = (currentTime) => {
                if (!startTime) {
                    startTime = currentTime;
                }

                const progress = Math.min((currentTime - startTime) / duration, 1);
                const value = Math.floor(progress * (countTo - start) + start);
                element.innerText = value;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };

            requestAnimationFrame(step);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [counted, isVisible1, isVisible2]);

    return (
        <div className="home-skills">
            <div className="outer-container">
                <div className="home-inner-skills">
                    <div className="home-inner-skills-overlay"></div>
                    <div className="home-skills-wrapper">
                        <div className="home-skills-wrapper-left">
                            <div className="home-whatwe-head text-white mb-3">Our Skills</div>
                            <div className={`home-whatwe-mainhead text-white mb-3 ${isVisible1 ? 'animate__fadeInUp' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef1}>Unleashing Your Path to Success</div>
                            <p className="main-para text-white">We specialize in connecting talented individuals with the perfect career opportunities. Our tailored approach ensures your skills meet the right job opportunities, enhancing your professional growth.</p>
                            <div className="home-counter">
                                <div className="home-counter-inner">
                                    <div className="home-counter-head">Hiring
                                        <span className="home-counter-span" style={{ left: '94%' }}>
                                            <span ref={(el) => (countRefs.current[0] = el)} data-count="94">0</span><span>%</span>
                                        </span>
                                    </div>
                                    <div className="home-counter-bar">
                                        <div ref={(el) => (barRefs.current[0] = el)} className="home-counter-inner-bar" data-width="94"></div>
                                    </div>
                                </div>
                                <div className="home-counter-inner">
                                    <div className="home-counter-head">RECRUITMENT
                                        <span className="home-counter-span" style={{ left: '86%' }}>
                                            <span ref={(el) => (countRefs.current[1] = el)} data-count="86">0</span><span>%</span>
                                        </span>
                                    </div>
                                    <div className="home-counter-bar">
                                        <div ref={(el) => (barRefs.current[1] = el)} className="home-counter-inner-bar" data-width="86"></div>
                                    </div>
                                </div>
                                <div className="home-counter-inner">
                                    <div className="home-counter-head">DEVELOPMENT
                                        <span className="home-counter-span" style={{ left: '75%' }}>
                                            <span ref={(el) => (countRefs.current[2] = el)} data-count="75">0</span><span>%</span>
                                        </span>
                                    </div>
                                    <div className="home-counter-bar">
                                        <div ref={(el) => (barRefs.current[2] = el)} className="home-counter-inner-bar" data-width="75"></div>
                                    </div>
                                </div>
                                <div className="home-counter-inner">
                                    <div className="home-counter-head">INTERVIEW
                                        <span className="home-counter-span" style={{ left: '80%' }}>
                                            <span ref={(el) => (countRefs.current[3] = el)} data-count="80">0</span><span>%</span>
                                        </span>
                                    </div>
                                    <div className="home-counter-bar">
                                        <div ref={(el) => (barRefs.current[3] = el)} className="home-counter-inner-bar" data-width="80"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home-skills-wrapper-right">
                            <div className={`home-skills-wrapper-right-inner ${isVisible2 ? 'animate__fadeInDown' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef2}>
                                <img src={skillsImg} className="img-fluid" alt="skill" width="640" height="959" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
